import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

/**
 * Module-level token store — updated synchronously by AuthContext.
 *
 * Using a plain variable (not React state) avoids the race condition where
 * child component effects fire before the parent AuthContext useEffect can
 * re-register the interceptor with the new token.
 */
let _accessToken = null;

export const setApiToken   = (token) => { _accessToken = token; };
export const clearApiToken = ()      => { _accessToken = null;  };
/** Read-only access for ErrorBoundary, which reports crashes with a bare
 * axios call rather than this configured client — module state like this
 * survives even when the React tree itself has crashed. */
export const getApiToken   = ()      => _accessToken;

/** Registered once — always reads the current module-level token. */
api.interceptors.request.use((config) => {
  if (_accessToken) {
    config.headers.Authorization = `Bearer ${_accessToken}`;
  }
  return config;
});

export default api;
